<template>
  <div class="t-24 fw-7"> Roll History </div>
  <div v-if="rolls.length === 0" class="t italics m-tx2">No rolls yet...</div>
  <div v-else class="max-h-x80 of-y-s b-1-gray m-tx2">
    <div v-for="roll in rolls" class="f-ac m-x4 p-x2 bg-gray-light">
      <div class="t-24 fw-6 w-x15">{{ roll.result }}</div>
      <div>
        <div class="t-18 fw-6">{{ roll.title }}</div>
        <div class="t-14 fw-5 m-t4">{{ rollTime(roll) }}</div>
        <div class="t-14 fw-5 m-t4">{{ roll.dice }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useCombatEncounterStore } from "../../../stores/combat_encounter_store.js";

  const store = useCombatEncounterStore();
  const rolls = computed(() => store.diceRolls.toReversed());

  const rollTime = (roll) => {
    return new Date(roll.id).toLocaleTimeString();
  }
</script>